import { cn } from "@utils/utils"

export const Skeleton = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
  return <div className={cn("animate-pulse rounded-full bg-neutral-10", className)} {...props} />
}

export default Skeleton
